const AI_SKILLS_SLUG_LIST: ReadonlyArray<string> = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-cybersecurity',
  'adobe-content-creator',
  'adobe-graphic-designer',
  'adobe-marketing-specialist',
  'microsoft-power-bi-data-analyst',
  'microsoft-cybersecurity-analyst',
  'ibm-data-engineer',
  'ibm-data-science',
  'facebook-social-media-marketing',
  'facebook-marketing-analytics',
  'ibm-full-stack-cloud-developer',
  'ibm-data-analyst',
  'microsoft-public-relations',
  'ux-design',
  'microsoft-it-support-specialist',
  'google-cloud-cybersecurity-certificate',
  'google-cloud-data-analytics-certificate',
  'meta-data-analyst',
  'ibm-ai-product-manager',
  'microsoft-cloud-support-associate',
  'microsoft-business-analyst',
  'microsoft-project-management',
  'amazon-junior-software-developer',
  'ai-machinelearning-essentials',
  'data-analytics',
  'fast-prototyping-of-genai-apps-with-streamlit',
  'retrieval-augmented-generation-rag',
  'ibm-backend-development',
  'ibm-cybersecurity-analyst',
  'ibm-deep-learning-with-pytorch-keras-tensorflow',
  'devops-and-software-engineering',
  'ibm-digital-marketing-and-growth-hacking',
  'ibm-ios-android-mobile-app-developer-pc',
  'java-developer',
  'ibm-program-manager',
  'ibm-relational-database-administrator',
  'ibm-systems-analyst',
  'aws-cloud-technical-essentials',
  'aws-generative-ai-developers',
  'aws-generative-ai-applications',
  'pytorch-for-deep-learning',
  'design-develop-and-deploy-multi-agent-systems-with-crewai',
  'prompting-essentials-google',
  'ai-essentials-google',
];

export const shouldShowAiSkillsBadge = (slug: string) => {
  return !!AI_SKILLS_SLUG_LIST.includes(slug);
};
